<template>
	<div
		:class="[
			'numbers',
			disabledInput ? 'disabledInput' : '',
			disabledInputInternal ? 'disabledInput' : '',
			keyboardOnly ? 'd-none' : '',
		]"
	>
		<template v-if="customButtons">
			<div class="numpadrow" v-for="(cnumbers, idx) in customButtons" :key="idx">
				<template v-for="number in cnumbers">
					<div @click.prevent="clr()" class="number error" :key="number" v-if="number == 'clr'">
						{{ __("games.clear") }}
					</div>
					<div @click.prevent="sendSingle()" class="number success" :key="number" v-else-if="number == 'check'">
						{{ __("games.send") }}
					</div>
					<div @click.prevent="hit(1)" class="number success" v-else-if="number == 'hit'" :key="number">HIT</div>
					<div @click.prevent="hit(1)" class="number" v-else-if="number == '1hit'" :key="number">1 HIT</div>
					<div @click.prevent="hit(2)" class="number" v-else-if="number == '2hit'" :key="number">2 HITS</div>
					<div @click.prevent="hit(3)" class="number" v-else-if="number == '3hit'" :key="number">3 HITS</div>
					<div @click.prevent="nohit()" class="number error" v-else-if="number == 'nohit'" :key="number">NO HIT</div>
					<div @click.prevent="hitsend(0)" class="number error" v-else-if="number == 'nohit_send'" :key="number">
						NO HIT
					</div>
					<div @click.prevent="hitsend(1)" class="number success" v-else-if="number == '1hit_send'" :key="number">
						1 HIT
					</div>
					<div @click.prevent="hitsend(2)" class="number success" v-else-if="number == '2hit_send'" :key="number">
						2 HITS
					</div>
					<div @click.prevent="hitsend(3)" class="number success" v-else-if="number == '3hit_send'" :key="number">
						3 HITS
					</div>
					<div @click.prevent="hitsend(1)" class="number success" v-else-if="number == 'be_send'" :key="number">
						BE
					</div>
					<div @click.prevent="hitsend(2)" class="number success" v-else-if="number == 'dbe_send'" :key="number">
						DBE
					</div>
                    <div @click.prevent="bullsend(1)" class="bull number" v-else-if="number == 'bull_1'" :key="number">
						{{__('games.player1_wins_bull')}}
                        <div class="bull-indicator-container">
                            <div :class="['bull-indicator', bullwinners[0] > 0 ? 'success' : '']"></div>
                            <div :class="['bull-indicator', bullwinners[0] > 1 ? 'success' : '']"></div>
                        </div>
					</div>
                    <div @click.prevent="bullsend(2)" class="bull number" v-else-if="number == 'bull_2'" :key="number">
						{{__('games.player2_wins_bull')}}
                        <div class="bull-indicator-container">
                            <div :class="['bull-indicator', bullwinners[1] > 0 ? 'success' : '']"></div>
                            <div :class="['bull-indicator', bullwinners[1] > 1 ? 'success' : '']"></div>
                        </div>
					</div>
                    <div @click.prevent="bullsend(3)" class="bull number" v-else-if="number == 'bull_3'" :key="number">
						{{__('games.nowinner_bull')}}
                        <div class="bull-indicator-container">
                            <div :class="['bull-indicator', bullwinners[2] > 0 ? 'success' : '']"></div>
                            <div :class="['bull-indicator', bullwinners[2] > 1 ? 'success' : '']"></div>
                        </div>
					</div>
					<div @click.prevent="addSingle(number)" class="number" :key="number" v-else>{{ number }}</div>
				</template>
			</div>
		</template>
		<template v-else>
			<div class="numpadrow">
				<div
					@click.prevent="checkout()"
					:class="['number', disabledCheckout() ? 'disabled' : 'success']"
					v-if="notHidden('check')"
				>
					{{ __("games.check") }}
				</div>
				<div class="clear" v-if="!notHidden('check')"></div>
				<div class="clear"></div>
				<div @click.prevent="rest()" class="number darker" v-if="notHidden('rest')">{{ __("games.rest") }}</div>
				<div class="clear" v-if="!notHidden('rest')"></div>
				<div @click.prevent="sendQuick(quicks[0])" class="number quick" v-if="notHidden('quick')">{{ quicks[0] }}</div>
			</div>
			<div class="numpadrow">
				<div @click.prevent="add(1)" class="number">1</div>
				<div @click.prevent="add(2)" class="number">2</div>
				<div @click.prevent="add(3)" class="number">3</div>
				<div @click.prevent="sendQuick(quicks[1])" class="number quick" v-if="notHidden('quick')">{{ quicks[1] }}</div>
			</div>
			<div class="numpadrow">
				<div @click.prevent="add(4)" class="number">4</div>
				<div @click.prevent="add(5)" class="number">5</div>
				<div @click.prevent="add(6)" class="number">6</div>
				<div @click.prevent="sendQuick(quicks[2])" class="number quick" v-if="notHidden('quick')">{{ quicks[2] }}</div>
			</div>
			<div class="numpadrow">
				<div @click.prevent="add(7)" class="number">7</div>
				<div @click.prevent="add(8)" class="number">8</div>
				<div @click.prevent="add(9)" class="number">9</div>
				<div @click.prevent="sendQuick(quicks[3])" class="number quick" v-if="notHidden('quick')">{{ quicks[3] }}</div>
			</div>
			<div class="numpadrow">
				<div @click.prevent="clr()" class="number error">{{ __("games.clear") }}</div>
				<div @click.prevent="add(0)" class="number">0</div>
				<div @click.prevent="send()" class="number success">{{ __("games.send") }}</div>
				<div @click.prevent="sendQuick(quicks[4])" class="number quick" v-if="notHidden('quick')">{{ quicks[4] }}</div>
			</div>
		</template>

		<b-modal id="modal-checkout" title="Check Out" size="lg" hide-footer>
			<h1 class="text-center" v-html="__('games.how_many_darts')"></h1>
			<div class="row">
				<div class="col-lg-3 col-12" @click.prevent="check(1)">
					<div class="btn-checkout btn btn-block btn-success">
						1
						<div class="smalltext">{{ __("games.darts") }}</div>
					</div>
				</div>
				<div class="col-lg-3 col-12" @click.prevent="check(2)">
					<div class="btn-checkout btn btn-block btn-success">
						2
						<div class="smalltext">{{ __("games.darts") }}</div>
					</div>
				</div>
				<div class="col-lg-3 col-12" @click.prevent="check(3)">
					<div class="btn-checkout btn btn-block btn-success">
						3
						<div class="smalltext">{{ __("games.darts") }}</div>
					</div>
				</div>
				<div class="col-lg-3 col-12" @click.prevent="check(0)">
					<div class="btn-checkout btn btn-block btn-danger">
						X
						<div class="smalltext" v-html="__('games.overthrown')"></div>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal id="modal-numpad-helper" :title="__('games.input_help')" size="md" hide-footer>
			<h3 v-html="__('games.keyboard_input')"></h3>
			<p v-html="__('games.keyboard_input_text')"></p>
			<table class="table table-striped">
				<thead>
					<tr>
						<th>{{ __("games.value") }}</th>
						<th>{{ __("games.shortcut") }}</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th>{{ __("games.numbers_1_to_0") }}</th>
						<td>
							{{ __("games.upper_row") }} <span class="key__button">1</span> {{ __("games.to") }}
							<span class="key__button">0</span><br /><br />{{ __("games.numblock") }}
							<span class="key__button">1</span> {{ __("games.to") }} <span class="key__button">0</span>
						</td>
					</tr>
					<tr>
						<th>{{ __("games.send") }}</th>
						<td><span class="key__button">ENTER</span> {{ __("games.or") }} <span class="key__button">RETURN</span></td>
					</tr>
					<tr>
						<th>{{ __("games.delete_value") }}</th>
						<td>
							<span class="key__button">{{ __("games.backspace") }}</span>
						</td>
					</tr>
					<tr>
						<th>{{ __("games.checkout_window") }}</th>
						<td>
							<span class="key__button">{{ __("games.spacebar") }}</span>
						</td>
					</tr>
					<tr>
						<th>{{ __("games.quick_input") }} 26, 45, 60, 85, 100 ({{ __("games.only") }} x01)</th>
						<td>
							<span class="key__button">SHIFT</span> + <span class="key__button">1</span>,
							<span class="key__button">2</span>, <span class="key__button">3</span>,
							<span class="key__button">4</span>,
							<span class="key__button">5</span>
							{{ __("games.in_upper_row") }}
						</td>
					</tr>
					<tr>
						<th>{{ __("games.rest") }} ({{ __("games.only") }} x01)</th>
						<td>
							{{ __("games.after_throw") }} <span class="key__button">SHIFT</span> +
							<span class="key__button">ENTER</span>/<span class="key__button">RETURN</span>
						</td>
					</tr>
				</tbody>
			</table>
		</b-modal>
	</div>
</template>

<script>
export default {
	props: ["disabledInput", "game_id", "hide", "only", "keyboardOnly"],
	data() {
		return {
			checkWindowOpen: false,
			quicks: [26, 45, 60, 85, 100],
			customButtons: null,
			keyboard_shortcuts: [],
			hideCheck: this.hide ? this.hide : [],
			numpadTempScore: "",
			disabledInputInternal: false,
			gameState: null,
            bullwinners: [0,0,0],
            numpadOptions: []
		};
	},
	created() {
		if (this.only) {
			this.hideCheck = ["rest", "quick", "check"];
		}
		window.addEventListener("keyup", this.keyboardInput);
	},

	beforeDestroy() {
		window.removeEventListener("keyup", this.keyboardInput);
	},
	watch: {
		disabledInput: function (val) {
			//always clear temp score if disabled state changes
			this.numpadTempScore = "";
		},
	},
	mounted() {
		this.addPlayerOptions();

		window.connection.subscribe(this);
		this.update(window.connection.lastUpdate);

        this.$root.$on('score-array-to-numpad', (data) => {
            this.parseAndSendArray(data);
        });
	},
	methods: {
		update(data) {
			if (data == null) return;
			this.gameState = data.gameState;
			if (data.gameState.customButtons) {
				this.customButtons = data.gameState.customButtons;
			} else {
				this.customButtons = null;
			}
            if (data.gameState.numpadOptions) {
                this.numpadOptions = data.gameState.numpadOptions;
            }

			if (data.action == "nextPlayer") {
				//force reset
				this.numpadTempScore = "";
			}
            this.checkBullDisplay();
		},
		add(number) {
			if (this.disabledInput) return;
            this.backupScore = this.numpadTempScore + "";
			this.numpadTempScore += "" + number;
            if (this.numpadOptions) {
                if (this.numpadOptions.direction && this.numpadOptions.direction == -1) {
                    var allow = true;
                    if (this.numpadOptions.max && parseInt(this.numpadTempScore) > this.numpadOptions.max) allow = false;
                    if (allow) {
                        this.$root.$emit('numpad-modify-currentscore', -parseInt(this.numpadTempScore), parseInt(this.numpadTempScore));
                    }
                }
                if (this.numpadOptions.direction && this.numpadOptions.direction == 1) {
                    var allow = true;
                    if (this.numpadOptions.max && parseInt(this.numpadTempScore) > this.numpadOptions.max) allow = false;
                    if (allow) {
                        this.$root.$emit('numpad-modify-currentscore', parseInt(this.numpadTempScore), parseInt(this.numpadTempScore));
                    }
                }
            }
			// clearTimeout(this.sendInputTimer);
			// this.sendInputTimer = setTimeout(() => {
			// 	axios.post("/api/sendNumpadInput", { game: this.game_id, input: this.numpadTempScore }).then((e) => {
            //         if (e.data == 500) {
            //             this.numpadTempScore = this.backupScore;
            //         }
            //     });
			// }, 10);
		},
		addSingle(number) {
			axios.post("/api/sendNumpadInputSingle", { dart: number }).then((e) => {
				this.disabledInputInternal = false;
			});
		},
		clr() {
			axios.post("/api/sendNumpadCommand", { command: "clear" }).then((e) => {
				this.disabledInputInternal = false;
			});
			this.numpadTempScore = "";
		},
		send() {
			if (!this.sendToApi({ input: this.numpadTempScore, saveInput: true })) return;
			this.numpadTempScore = 0;
		},
		sendSingle() {
			axios.post("/api/sendNumpadCommand", { command: "next_player" }).then((e) => {
				this.disabledInputInternal = false;
			});
		},
        sendMultiple(arr) {
			axios.post("/api/sendNumpadMultiple", { darts: arr}).then((e) => {
				this.disabledInputInternal = false;
			});
		},
		sendQuick(score) {
			if (!this.sendToApi({ input: score, saveInput: true })) return;
			this.numpadTempScore = 0;
		},
		hit(hits) {
			axios.post("/api/sendNumpadInputSingle", { dart: this.gameState.hitNumber, times: hits }).then((e) => {
				this.disabledInputInternal = false;
			});
		},
		nohit() {
			axios.post("/api/sendNumpadInputSingle", { dart: 0 }).then((e) => {
				this.disabledInputInternal = false;
			});
		},
		hitsend(hits) {
			if (hits == 0) this.gameState.hitNumber = 0;
			axios
				.post("/api/sendNumpadInputSingle", { dart: this.gameState.hitNumber, times: hits, saveInput: true })
				.then((e) => {
					this.disabledInputInternal = false;
				});
		},
        bullsend(player) {
			axios
				.post("/api/sendNumpadCommand", { command: "bullwon_"+player, saveInput: true })
				.then((e) => {
					this.disabledInputInternal = false;
				});
		},
		check(dart) {
			if (!this.sendToApi({ input: 0, checkdarts: dart, saveInput: true })) return;
			this.hideCheckoutWindow();
		},
		checkout() {
			if (this.disabledInput) return;
			if (this.hideCheck.indexOf("check") != -1) return; //do not allow check when check should not be visible
			//check is only available when current player has less than 180 points remaining
			if (this.gameState.scores[this.gameState.currentPlayerIndex].score > 180) return;
			this.$bvModal.show("modal-checkout");
			this.checkWindowOpen = true;
		},
		disabledCheckout() {
			if (this.gameState == null) return false;
			return this.gameState.scores[this.gameState.currentPlayerIndex].score > 180;
		},
		hideCheckoutWindow() {
			this.$bvModal.hide("modal-checkout");
			this.checkWindowOpen = false;
		},
		rest() {
			if (this.hideCheck.indexOf("rest") != -1) return; //do not allow rest when rest should not be accessible
			if (this.numpadTempScore <= 1) return; //do not allow rest to be 0 or less
			if (!this.sendToApi({ input: this.numpadTempScore, rest: true, saveInput: true })) return;
		},
		toggleHelper() {
			this.$bvModal.show("modal-numpad-helper");
		},
		notHidden(option) {
			if (!this.hideCheck) return true;
			var returnValue = true;
			this.hideCheck.forEach((element) => {
				if (element == option) {
					returnValue = false;
				}
			});
			return returnValue;
		},
		sendToApi(data) {
			if (this.disabledInput || this.disabledInputInternal) return false;
			this.disabledInputInternal = true;
			this.disabledInputInternal = false; //debug
			clearTimeout(this.sendInputTimer);
			data.game = this.game_id;
			axios.post("/api/sendNumpadInput", data).then((e) => {
				this.disabledInputInternal = false;
			});
			return true;
		},
		keyboardInput(ev) {
			//debug reset leg
			if (ev.shiftKey && ev.ctrlKey && ev.code == "KeyL") {
				window.connection.resetLeg();
			}
			//do not allow inputs if input is disabled
			if (this.disabledInput) return;
			if (this.checkWindowOpen) {
				if (ev.code == "Backspace" || ev.code == "Escape") {
					this.hideCheckoutWindow();
				}
				for (let i = 1; i <= 3; i++) {
					if (ev.code == "Numpad" + i || ev.code == "Digit" + i) this.check(i);
				}
				//overthrown with number 4
				if (ev.code == "Numpad4" || ev.code == "Digit4") this.check(0);
			} else {
				//create string from pressed buttons
				let pressedKeys = "";
				if (ev.shiftKey) pressedKeys += "SHIFT + ";
				if (ev.altKey) pressedKeys += "ALT + ";
				if (ev.controlKey || ev.ctrlKey) pressedKeys += "CTRL + ";
				pressedKeys += ev.code;
				//check against shortcuts
				let foundShortcut = undefined;
				this.keyboard_shortcuts.forEach((shortcut) => {
					if (shortcut.value == pressedKeys) {
						foundShortcut = shortcut.name;
					}
				});

				if (foundShortcut) {
					if (foundShortcut == "keyboard_nextplayer") {
						this.send();
						return;
					}
					if (foundShortcut == "keyboard_clear") {
						this.clr();
						return;
					}
					if (foundShortcut == "keyboard_rest") {
						this.rest();
					}
					if (foundShortcut == "keyboard_check") {
						this.checkout();
					}
					if (foundShortcut.indexOf("quick") != -1) {
						let quick = parseInt(foundShortcut.replace("keyboard_quick", "")) - 1;
						this.sendQuick(this.quicks[quick]);
					}
				}

				if (this.only && this.only.indexOf("hit-nohit") != -1) {
					if (ev.code == "Numpad1" || ev.code == "Digit1") this.hit();
					if (ev.code == "Numpad2" || ev.code == "Digit2") this.nohit();
				} else {
					for (let i = 0; i < 10; i++) {
						if (ev.code == "Numpad" + i || ev.code == "Digit" + i) this.add(i);
					}
				}
			}
		},
		addPlayerOptions() {
			setTimeout(() => {
				if (window.player == null) return;
				this.quicks = [];
				for (const key in window.player) {
					if (Object.hasOwnProperty.call(window.player, key)) {
						const element = window.player[key];
						if (key.indexOf("keyboard") != -1) this.keyboard_shortcuts.push({ name: key, value: element });
						if (key.indexOf("value_quick") != -1) {
							this.quicks.push(element);
						}
					}
				}
			}, 1000);
		},
        checkBullDisplay() {
            if (!this.gameState || !this.gameState.throws || !this.gameState.throws.throws[0] || !this.gameState.throws.throws[0].bullwinner) return;
            else {
                this.bullwinners = [0,0,0];
                this.gameState.throws.throws.forEach(t => {
                    this.bullwinners[t.bullwinner-1] += 1;
                });
            }
        },
        parseAndSendArray(arr) {
            //takes single number arrays and changes to singlescores, then send
            arr.sort(function(a, b) {
              return a - b;
            });
            let returnArray = [];
            let counts = {};
            arr.forEach(el => counts[el] = 1  + (counts[el] || 0))
            for (const property in counts) {
                if (property == 25) {
                    if (counts[property] == 1) returnArray.push(property);
                    if (counts[property] == 2) returnArray.push("D"+property);
                    if (counts[property] == 3) returnArray.push("D"+property, property);
                    if (counts[property] == 4) returnArray.push("D"+property,"D"+property);
                    if (counts[property] == 5) returnArray.push("D"+property,property,"D"+property);
                    if (counts[property] == 6) returnArray.push("D"+property,"D"+property,"D"+property);
                } else {
                    if (counts[property] == 1) returnArray.push(property);
                    if (counts[property] == 2) returnArray.push("D"+property);
                    if (counts[property] == 3) returnArray.push("T"+property);
                    if (counts[property] == 4) returnArray.push(property,"T"+property);
                    if (counts[property] == 5) returnArray.push("D"+property,"T"+property);
                    if (counts[property] == 6) returnArray.push("T"+property,"T"+property);
                    if (counts[property] == 7) returnArray.push("T"+property,"T"+property,property);
                    if (counts[property] == 8) returnArray.push("T"+property,"D"+property,"D"+property);
                    if (counts[property] == 9) returnArray.push("T"+property,"T"+property,"T"+property);
                }
            }
            this.sendMultiple(returnArray);
        }
	},
};
</script>

<style scoped>
.btn-number {
	width: 100%;
	height: 10vh;
	text-align: center;
	line-height: 10vh;
	font-size: 5em;
	background-color: #ddd;
	color: #333;
	font-weight: bold;
	margin-top: 2vh;
}

.btn-clr {
	background-color: red;
	color: #fff;
}

.btn-send {
	background-color: green;
	color: #fff;
}

.btn-check {
	background-color: rgb(107, 107, 107);
	color: #fff;
}

.btn-check.btn-check-allowed {
	background-color: green;
	color: #fff;
}

.btn-check.btn-check-disabled {
	background-color: rgb(107, 107, 107);
	color: #fff;
}

.btn-checkout {
	height: 120px;
	text-align: center;
	line-height: 1em;
	font-size: 6em;
	font-weight: bold;
	margin-top: 2vh;
}

.btn-checkout .smalltext {
	font-size: 0.25em;
	margin-top: -2em;
}

.key__button {
	box-sizing: border-box;
	font-size: 1rem;
	text-align: center;
	min-width: 2em;
	padding: 0 1em;
	color: #555;
	cursor: pointer;
	margin: 0 8px;
	border-color: #f2f2f2;
	border-style: solid;
	text-shadow: 0 0.5px 1px #777, 0 2px 6px #f2f2f2;
	border-width: 1px;
	border-radius: 10px;
	background: -webkit-linear-gradient(top, #f9f9f9 0%, #d2d2d2 80%, #c0c0c0 100%);
	font-family: sans-serif;
	display: inline-block;
	transition: box-shadow 0.3s ease, transform 0.15s ease;
	box-shadow: 0 0 1px #888, 0 1px 0 #fff, 0 3px 10px #aaa;
}

.bull {
    font-size: 2vw;
    line-height: normal;
    min-height: auto;
    width: 30vw;
    height: 8vw;
    display: flex;
    justify-content: center;
    flex-direction: column;
}
.bull .bull-indicator-container {
    display: flex;
    gap: 0.25em;
    justify-content: center;
    margin-bottom: 0.125em;
}
.bull .bull-indicator {
    border: 1px solid #000;
    background-color: #f2f2f2;
    display: block;
    width: 1em;
    height: 1em;
}
.bull .bull-indicator.success {
    background-color: #009948;
}
</style>
